import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  position: relative;
  width: 250px;
  height: 56px;

  @media (max-width: 1023px) {
    flex: 1;
    width: auto;
    min-width: 0;
  }
`;
